import React from "react";
import { Typography } from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import styled from "styled-components";

const TERM_OPTIONS = [
  { value: 1, label: "일" },
  { value: 2, label: "주" },
  { value: 3, label: "월" },
];

function PeriodToolbar({ title, term, onTermChange, date, onDateChange }) {
  return (
    <Header>
      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        {title}
      </Typography>
      <Controls>
        <TermSwitch role="tablist" aria-label="기간 단위">
          {TERM_OPTIONS.map((option) => (
            <TermOption
              key={option.value}
              type="button"
              $active={Number(term) === option.value}
              onClick={() => onTermChange(option.value)}
            >
              {option.label}
            </TermOption>
          ))}
        </TermSwitch>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          dateFormats={{ monthShort: "M" }}
          adapterLocale="ko"
        >
          <DatePicker
            format="YYYY. MM. DD"
            value={date}
            onChange={onDateChange}
            shouldDisableDate={(day) => {
              const today = dayjs().startOf("day");
              return dayjs(day).isAfter(today, "day");
            }}
            slotProps={{
              textField: {
                placeholder: "기준일",
                size: "small",
              },
            }}
          />
        </LocalizationProvider>
      </Controls>
    </Header>
  );
}

export default PeriodToolbar;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
`

const Controls = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .MuiPickersTextField-root,
    .MuiFormControl-root {
        min-width: 168px;
    }

    .MuiOutlinedInput-root {
        height: 40px;
        border-radius: 10px;
        background: #eef1f7;
        font-size: 13px;
        font-weight: 600;
        color: #334155;
        letter-spacing: -0.2px;
    }

    .MuiOutlinedInput-notchedOutline {
        border: none;
    }

    .MuiInputLabel-root {
        display: none;
    }
`

const TermSwitch = styled.div`
    display: inline-flex;
    align-items: stretch;
    height: 40px;
    box-sizing: border-box;
    padding: 3px;
    background: #eef1f7;
    border-radius: 10px;
    gap: 2px;
`

const TermOption = styled.button`
    border: none;
    background: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
    color: ${({ $active }) => ($active ? "#536DFE" : "#7b8194")};
    box-shadow: ${({ $active }) => ($active ? "0 1px 4px rgba(15, 23, 42, 0.1)" : "none")};
    padding: 0 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.2px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;

    &:hover {
        color: ${({ $active }) => ($active ? "#536DFE" : "#4a4f63")};
    }
`
